module.exports = __webpack_public_path__ + "img/geartype.285ef51e.svg";